import { render, staticRenderFns } from "./MerchantReturns.vue?vue&type=template&id=4d0767a4&scoped=true"
import script from "./MerchantReturns.vue?vue&type=script&lang=js"
export * from "./MerchantReturns.vue?vue&type=script&lang=js"
import style0 from "./MerchantReturns.vue?vue&type=style&index=0&id=4d0767a4&prod&scoped=true&lang=css"
import style1 from "./MerchantReturns.vue?vue&type=style&index=1&id=4d0767a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0767a4",
  null
  
)

export default component.exports